import axios from '../../../utils/axios'

export default {
    GetBookingByTrainingId (id) {
        return axios.get('Training/' + id + '/Booking')
            .then(response => {
                return response.data
            })
    },
    CreateBooking (trainingId, booking) {
        return axios.post('Training/' + trainingId + '/Booking', booking)
        .then(response => {
            return response.data
        })
    },
    UpdateBooking (bookingId, booking) {
        return axios.put('Training/Booking/' + bookingId, booking)
    },
}
